import { ArrowRight } from 'lucide-react'
import Link from 'next/link'
import type { HubConcernLinksSection, HubSectionComponentProps } from './types'

export function HubConcernLinks({
  section,
}: HubSectionComponentProps<HubConcernLinksSection>) {
  if (section.links.length === 0) return null

  return (
    <section
      id={section.id}
      aria-label={section.title ?? section.prompt ?? 'Related links'}
      className='flex flex-col gap-3 rounded-2xl border border-border bg-accent px-5 py-4'
    >
      {(section.title || section.prompt) && (
        <p className='text-sm font-medium text-foreground'>
          {section.title ?? section.prompt}
        </p>
      )}

      <ul className='flex flex-wrap gap-2' role='list'>
        {section.links.map((link) => (
          <li key={`${link.label}-${link.href}`}>
            <Link
              href={link.href}
              className='inline-flex items-center gap-1 rounded-full border border-border bg-white px-3 py-1.5 text-sm font-medium text-foreground-secondary transition-colors hover:border-foreground-secondary hover:text-foreground'
            >
              {link.label}
              <ArrowRight className='size-3.5' aria-hidden />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  )
}
